import {
  BarChart3,
  BookOpenCheck,
  Bot,
  CalendarClock,
  ClipboardList,
  ClipboardCheck,
  FileCheck2,
  Settings,
  Sparkles,
  UserSearch,
  Users,
  WalletCards,
  type LucideIcon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";

type ModuleDefinition = {
  to: string;
  label: string;
  detail: string;
  icon: LucideIcon;
  permission: string;
  tone: string;
};

export const sanruModules: ModuleDefinition[] = [
  { to: "/pilotage", label: "Vue d’ensemble", detail: "Indicateurs, alertes et décisions", icon: BarChart3, permission: "dashboard.view", tone: "blue" },
  { to: "/personnel", label: "Personnel", detail: "Dossiers, documents et Odoo", icon: Users, permission: "employees.view", tone: "green" },
  { to: "/recrutement", label: "Recrutement", detail: "Offres, ATS et candidatures", icon: UserSearch, permission: "recruitment.view", tone: "orange" },
  { to: "/tests-recrutement", label: "Tests de recrutement", detail: "Questionnaires, salles et corrections", icon: ClipboardCheck, permission: "recruitment.view", tone: "red" },
  { to: "/conges", label: "Congés & Timesheets", detail: "Congés Odoo et feuilles de temps", icon: CalendarClock, permission: "leave.view", tone: "pink" },
  { to: "/paie", label: "Paie & salaires", detail: "Calculs et bulletins USD", icon: WalletCards, permission: "payroll.view", tone: "indigo" },
  { to: "/formation", label: "Formation & évaluation", detail: "Cours, tests, progression et badges", icon: BookOpenCheck, permission: "training.view", tone: "olive" },
  { to: "/analytique", label: "Analytique RH", detail: "Prévisions, risques et compétences", icon: Sparkles, permission: "analytics.view", tone: "purple" },
  { to: "/assistant-ia", label: "Assistant IA", detail: "Synthèses conversationnelles", icon: Bot, permission: "ai.use", tone: "teal" },
  { to: "/taches-rh", label: "Tâches RH", detail: "Planification et suivi de l’équipe", icon: ClipboardList, permission: "employees.view", tone: "red" },
  { to: "/demandes", label: "Gestion des demandes", detail: "Avances, absences urgentes et validations", icon: FileCheck2, permission: "requests.view", tone: "orange" },
  { to: "/parametres", label: "Paramètres", detail: "Référentiels, sécurité et intégrations", icon: Settings, permission: "settings.manage", tone: "slate" },
];

export function ModuleLauncher({ compact = false, onChoose }: { compact?: boolean; onChoose?: () => void }) {
  const { can } = useAuth();
  return (
    <section className={compact ? "module-launcher-grid" : "module-hub"} aria-label="Applications SANRU RH">
      {sanruModules.filter((item) => can(item.permission)).map(({ to, label, detail, icon: Icon, tone }) => (
        <Link to={to} className={compact ? `launcher-card launcher-card--${tone}` : `module-card module-card--${tone}`} key={to} onClick={onChoose}>
          <span><Icon /></span><strong>{label}</strong>{!compact && <small>{detail}</small>}
        </Link>
      ))}
    </section>
  );
}
